// @flow

/* eslint react/no-did-mount-set-state:0 */
/* eslint react/forbid-prop-types:0 */

import React, { Component } from 'react';
import PinGridInner from 'app/common/react/components/growth/unauth/PinGrid/PinGridInner';
import PropTypes from 'prop-types';
import { getMaxColumns } from 'app/common/lib/react/gridUtils';
import type { PinType, SrcSetType } from 'app/common/react/components/growth/unauth/lib/PropTypes';
import withUnauthSeoExperiments, {
  type UnauthSeoExperiments,
} from 'app/common/lib/react/withUnauthSeoExperiments';

export type Props = {|
  bookmarks: Array<string>,
  carouselTagColor?: string,
  desktopUnauthRankingLoggingData?: {|
    id: string,
  |},
  disableDeeplinks?: boolean,
  hideAllMeta?: boolean,
  hideMeta?: boolean,
  hideTitle?: boolean,
  hideVaseTags?: boolean,
  hybridClickthroughHandler: () => void,
  isRelatedPin?: boolean,
  items: Array<PinType>,
  enableOrderedList?: boolean,
  loadPins: (
    Array<PinType>,
    Array<string>,
    (items: Array<PinType>, bookmarks: Array<string>) => void,
  ) => void,
  maxColumns?: number,
  maxPinImageHeight?: number,
  numServerRenderedPins: number,
  openInCurrentTab?: boolean,
  pinImageClickHandler?: () => void,
  pinImageSize?: string,
  pinImageSizeOverrides?: {| [string]: string |},
  pinImageWidthMax: number,
  pinImageWidthMin: number,
  pinWrapperBackgroundColor?: string,
  placeholderColSize: number,
  responsive?: boolean,
  scrollContainer?: HTMLElement,
  seoUnauthExperiments: UnauthSeoExperiments,
  showRelatedPinsHeader?: boolean,
  showSeeMore?: boolean,
  showSignupModal: (SyntheticEvent<>) => void,
  srcSet?: SrcSetType,
  vaseCarouselStyleOverrides?: {|
    [string]: {| [string]: string |},
  |},
  viewData: {| interest: string |},
  viewParameter?: number,
  viewType?: number,
|};

type State = {|
  bookmarks: Array<string>,
  items: Array<PinType>,
  numClickthroughs: number,
|};

type Context = {||};

export class PinGrid extends Component<Props, State> {
  static defaultProps = {
    pinImageSize: '236x',
    numServerRenderedPins: 0,
  };

  constructor(props: Props, context: Context) {
    super(props, context);
    const { items, numServerRenderedPins } = this.props;

    let initialItems = items;
    if (!this.context.isBot) {
      const pinCount = numServerRenderedPins > 0 ? numServerRenderedPins : getMaxColumns();

      initialItems = items.slice(0, pinCount);
    }

    this.state = {
      items: initialItems,
      bookmarks: this.props.bookmarks,
      numClickthroughs: 0,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (
      nextProps &&
      nextProps.items &&
      nextProps.items.length > 0 &&
      nextProps.items[0].type === 'placeholder' &&
      this.state.items[0].type === 'placeholder'
    ) {
      if (nextProps.items[0].height !== this.state.items[0].height) {
        const newPlaceholder = nextProps.items[0];
        const currentItems = this.state.items.slice();
        if (this.props.placeholderColSize) {
          currentItems.splice(0, this.props.placeholderColSize);
          for (let i = 0; i < this.props.placeholderColSize; i += 1) {
            currentItems.unshift(newPlaceholder);
          }
        }
        this.setState({ items: currentItems });
      }
    }
  }

  loadCallback = (items: Array<PinType>, bookmarks: Array<string>) => {
    this.setState({ items: this.state.items.concat(items), bookmarks });
  };

  loadPins = () => {
    this.props.loadPins(this.state.items, this.state.bookmarks, this.loadCallback);
  };

  pinLinkClickHandler = (e: SyntheticEvent<>) => {
    if (this.props.hybridClickthroughHandler) {
      e.stopPropagation();
      this.props.hybridClickthroughHandler();
      return;
    }
    this.setState({ numClickthroughs: this.state.numClickthroughs + 1 });
    if (this.state.numClickthroughs > 2) {
      this.props.showSignupModal(e);
      this.setState({ numClickthroughs: 1 });
    }
  };

  render() {
    const { bookmarks, items, loadPins, ...otherProps } = this.props;

    return (
      <PinGridInner
        pinLinkClickHandler={this.pinLinkClickHandler}
        items={this.state.items}
        loadPins={() => this.loadPins()}
        showRichPinAttribution
        {...otherProps}
      />
    );
  }
}

PinGrid.contextTypes = {
  isBot: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  logging: PropTypes.shape({
    viewParameter: PropTypes.number,
    viewType: PropTypes.number.isRequired,
    viewData: PropTypes.shape({
      interest: PropTypes.string,
    }),
  }),
  pageType: PropTypes.string,
};

export default withUnauthSeoExperiments(PinGrid);
